// @LTG-ID: page/journal-article (CHG-0102)
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: /app/docs/data-model/journal_content_v1.md,
//        07_PAGES_AND_ROUTES.md (route /journals/:slug)
// @CHANGED: 2026-05-29 session_007 (CHG-0102 · Journal MVP)
// @OWNER: web
//
// Dynamic renderer for the 20 CHG-0102 Journal MVP articles. Looks up the
// article BRIEF from the `_index.js` manifest by URL slug; if not found,
// hands off to the existing `JournalNotFound` component that already ships
// the "Did you mean..." panel for the two published legacy briefs.
//
// The article itself is rendered by the shared `<BriefPage>` shell, which in
// CHG-0102 v2 was upgraded to render either JSX children (legacy Brief 01/02)
// OR a markdown body payload (this route). See `BriefPage.jsx` for the mode
// detection.

import { useParams } from "react-router-dom";
import BriefPage from "../components/journals/BriefPage";
import JournalNotFound from "../components/journals/JournalNotFound";
import { JOURNAL_ARTICLES } from "../data/journals/_index";

export const JournalArticle = () => {
    const { slug } = useParams();
    const brief = JOURNAL_ARTICLES[slug];

    if (!brief) {
        return <JournalNotFound />;
    }

    return (
        <BriefPage
            frontmatter={brief.FRONTMATTER}
            bodyMarkdown={brief.BODY_MARKDOWN}
            faq={brief.FAQ}
            sources={brief.SOURCES}
            endCta={brief.END_CTA}
            readNext={brief.READ_NEXT}
        />
    );
};

export default JournalArticle;
